
<template>
  <span
    v-if="status==='APPROVED'"
    class="badge badge-success"
  > {{ $t('supplierOutgoingVendorRequest.tsdiqlnmi') }}</span>
  <span
    v-else-if="status==='READY'"
    class="badge badge-primary"
  > {{ $t('supplierOutgoingVendorRequest.hazrdr') }}</span>
  <span
    v-else-if="status==='DRAFT'"
    class="badge badge-dark"
  > {{ $t('myRequest.qaralama') }}</span>
  <span
    v-else-if="status==='WAITING'"
    class="badge badge-warning"
  > {{ $t('supplierOutgoingVendorRequest.gzlmd') }}</span>
  <span
    v-else-if="status==='RETURNED'"
    class="badge badge-info"
  > {{ $t('supplierOutgoingVendorRequest.geriQaytarlb') }}</span>
  <span
    v-else-if="status==='REJECTED'"
    class="badge badge-danger"
  > {{ $t('supplierOutgoingVendorRequest.lvEdilib') }}</span>
  <span
    v-else
    class="badge badge-primary"
  > {{ status }}</span>
</template>
<script>
export default {
  name: 'CompanyFormRequestStatus',
  props: {
    status: ''
  }
}
</script>